import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Button } from 'antd';
import styled from '@emotion/styled';

const ObjectivesAdminCreationErrorsModal = forwardRef((props, ref) => {
  const { onAccept: onSendJson } = props;
  const [errors, setErrors] = useState([]);
  const [visible, setVisible] = useState(false);
  const [jsonData, setJsonData] = useState(null);

  useImperativeHandle(ref, () => ({
    showErrors: (listErrors, jsonParam) => {
      setErrors(listErrors);
      setJsonData(jsonParam);
      setVisible(true);
    }
  }));

  const handleDownloadCSV = () => {
    const csvContent = errors.map(e => `"${e}"`).join('\n');
    const bom = '\uFEFF';
    const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'errores.csv';
    link.click();
  };

  const handleAccept = () => {
    if (onSendJson) {
      onSendJson(jsonData);
    }
    setVisible(false);
  }

  return (
    <CenteredTitleModal
      title="RESULTADOS DEL PROCESADO DEL FICHERO"
      centered
      width={800}
      closable={false}
      maskClosable={false}
      keyboard={false}
      open={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="ok" type="primary" onClick={handleAccept}>
          Aceptar
        </Button>,
        <Button key="download" onClick={handleDownloadCSV}>
          Descargar CSV
        </Button>,
      ]}
    >
      <>
        <div style={{
          height: '500px',
          overflowY: 'auto',
          whiteSpace: 'pre-wrap'
        }}
        >
          {errors.length > 0 ? (
            <>
              <p style={{ marginBottom: '10px' }}>
                Se han producido los siguientes errores durante el procesado del fichero:
              </p>
              {errors.map((err, idx) => (
                <div
                  key={idx}
                >
                  - {err}
                </div>
              ))}
            </>
          ) : (
            <p>No se han encontrado errores.</p>
          )}
        </div>
      </>
    </CenteredTitleModal>
  );
});

export default ObjectivesAdminCreationErrorsModal;


const CenteredTitleModal = styled(Modal)`
  .ant-modal-title {
    text-align: center;
    width: 100%;
  }
`;